import { render } from "./AddAccessory.vue?vue&type=template&id=018ea827"
import script from "./AddAccessory.vue?vue&type=script&lang=js"
export * from "./AddAccessory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__